import script from "./NombreDeBoxProp.vue?vue&type=script&setup=true&lang=js"
export * from "./NombreDeBoxProp.vue?vue&type=script&setup=true&lang=js"

import "./NombreDeBoxProp.vue?vue&type=style&index=0&id=3fcccb7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcccb7b"]])

export default __exports__